import AuthorizationPage from "@/pages/AuthorizationPage";
import AveleksPage from "@/pages/AveleksPage.vue";
import EventEditorPage from "@/pages/events/EventEditorPage";
import EventsListPage from "@/pages/events/EventsListPage";
import NotFoundPage from "@/pages/NotFoundPage.vue";
import FormsPage from "@/pages/personal/FormsPage";
import PersonalCabinetPage from "@/pages/personal/PersonalCabinetPage";
import SettingsPage from "@/pages/personal/SettingsPage";
import SeparateUserPage from "@/pages/users/SeparateUserPage";
import UsersChatPage from "@/pages/users/UsersChatPage";
import UsersListPage from "@/pages/users/UsersListPage";
import { canEnterToUserPortal } from "@/router/helpers";
import { createRouter, createWebHistory } from 'vue-router';


// creating routes to all pages
const routes = [
    {
        path: '/',
        name: 'authorization',
        component: AuthorizationPage,
        beforeEnter: async (to, from, next) => {
            await canEnterToUserPortal(async (token) => {
                if (token) {
                    next({name: 'users'});
                } else {
                    next();
                }
            });
        }
    },
    {
        path: '/cabinet',
        name: 'personalCabinet',
        component: PersonalCabinetPage,
        children: [
            {
                path: 'settings',
                name: 'settings',
                component: SettingsPage
            },
            {
                path: 'users',
                name: 'users',
                component: UsersListPage
            },
            {
                path: 'users/:id',
                name: 'separateUser',
                component: SeparateUserPage,
                props: true
            },
            {
                path: 'forms',
                name: 'forms',
                component: FormsPage
            },
            {
                path: 'support',
                name: 'support',
                component: () => import("@/pages/personal/SupportPage.vue"),
            },
            {
                path: 'statistics',
                name: 'statistics',
                component: () => import("@/pages/personal/StatisticsPage.vue"),
            },
            {
                path: 'chats',
                name: 'chats',
                component: UsersChatPage
            },
            {
                path: 'events',
                name: 'eventsList',
                component: EventsListPage
            },
            {
                path: 'aveleks-feedback',
                name: 'aveleks-feedback',
                component: AveleksPage,
            },
            {
                path: 'event/:id',
                name: 'eventEditor',
                props: true,
                component: EventEditorPage
            },
            {
                path: 'event/slots/:id',
                name: 'slotsSettings',
                props: true,
                component: () => import("@/pages/events/EventSlotsPageEditor.vue"),
            }


        ],
        beforeEnter: async (to, from, next) => {
            await canEnterToUserPortal( (token) => {
                if (token) {
                    next();
                } else {
                    next({name: 'authorization'});
                }
            });
        }
    },
    {
        path: "/:pathMatch(.*)*",
        component: NotFoundPage
    }
];

// creating Vue-Router instance with normal history mode
const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;